module.exports = __webpack_public_path__ + "static/wohngebaeude2-4fb05a46dbfc15e6e60dd3bee619783e.PNG";